import { render, staticRenderFns } from "./department-categories.vue?vue&type=template&id=835e0cba&scoped=true"
import script from "./department-categories.vue?vue&type=script&lang=ts"
export * from "./department-categories.vue?vue&type=script&lang=ts"
import style0 from "./department-categories.vue?vue&type=style&index=0&id=835e0cba&prod&lang=css"
import style1 from "./department-categories.vue?vue&type=style&index=1&id=835e0cba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835e0cba",
  null
  
)

export default component.exports